import { defineComponent as _defineComponent } from 'vue'
import { IColumnsGroup } from "@/utils/ColumnsCreator";
import BaseCheckbox from "@/components-UI/BaseCheckbox.vue";
import { useColumnsStore } from "@/store_v3/ColumnsStore";
import { computed } from "vue";
import { storeToRefs } from "pinia";

//TODO доделать чекбокс названия группы, который переключает все чекбоксы в группе

interface Props {
    group: IColumnsGroup;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ColumnsGroup',
  props: {
    group: null
  },
  setup(__props: any) {

const props = __props as {
    group: IColumnsGroup;
}


const { selected } = storeToRefs(useColumnsStore());
const { updateOneColumn } = useColumnsStore();

const getItems = computed(() => {
    return props.group.items.map((item) => {
        return {
            ...item,
            isSelected: selected.value.includes(item.value),
        };
    });
});

const updateSelected = (column: string) => {
    updateOneColumn(column);
};


return { __sfc: true,props, selected, updateOneColumn, getItems, updateSelected, BaseCheckbox }
}

})